<template>
<p class="p-link text-primary white-space-nowrap overflow-hidden text-overflow-ellipsis mt-2" 
style="width:100%;"
>{{realmessage}}</p>
</template>

<script>
export default {

  name: 'TicketListLine',
  props:["message"],
  data() {
    return {

    };
  },
  computed:{
  	realmessage()
  	{
  		let message = this.message
  		let index = message.indexOf("<br />");
  		let result = message.slice(0, index);
  		return result
  	}
  },
};
</script>

<style lang="css" scoped>
</style>
